import { CanDeactivateFn } from '@angular/router';
import { PontoDeVendaComponent } from '../pages/financeiro/components/ponto-de-venda.component/ponto-de-venda.component';

/** Saída da tela do PDV com itens no grid pede confirmação (e cancela o rascunho ao confirmar). */
export const pdvSaidaGuard: CanDeactivateFn<PontoDeVendaComponent> = (component) => component.podeSair();
